var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-page-title"},[_c('div',{staticClass:"content"},[_c('h1',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$app.router.current().title))]),_c('div',{staticClass:"locale"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }